import i18n from 'i18next'

import type { ProductType } from '../store/store.types'

export const getProductTypeName = (type: ProductType): string => {
  const name = {
    anomaly: i18n.t('Anomaly'),
    classification: i18n.t('Classification'),
    segmentation: i18n.t('Segmentation'),
    classification_patch: i18n.t('Patch'),
  }

  return name[type]
}

export const getProductClassesList = (
  type: ProductType,
  productClasses: string[]
): string => productClasses.join(', ')

export const isClassificationProduct = (type: ProductType): boolean =>
  type === 'classification'

export const isSegmentationProduct = (type: ProductType): boolean =>
  type === 'segmentation'
